import { createReducer, on } from "@ngrx/store";
import { onLoadableError, onLoadableLoad, onLoadableSuccess } from "../../models";
import { createInitialReportingState, IReportingState } from "./report.states";
import { ReportActions } from "./report.actions";
import { UserActions } from "../user/user.actions";

export const reportReducer = createReducer(
    createInitialReportingState(),

    on(ReportActions.loadReportList, state => ({ ...state, summaries: onLoadableLoad({ ...state.summaries, reports: [] }) })),
    on(ReportActions.loadReportListSuccess, (state, { reports }) => {
        return {
            ...state,
            summaries: onLoadableSuccess({ ...state.summaries, reports: [...reports]})
        }
    }),
    on(ReportActions.loadReportListFailure, (state, { error }) => ({ ...state, summaries: onLoadableError({ ...state.summaries }, error) })),

    on(ReportActions.setCurrentReport, (state, {report}) => ({...state, selectedReport: report })),
    on(ReportActions.clearCurrentReport, state => ({...state, selectedReport: null, selectedReportURL: {...state.selectedReportURL, url: null}})),

    on(ReportActions.getReportURL, (state): IReportingState => ({...state, selectedReportURL: {...onLoadableLoad(state.selectedReportURL), url: null}})),
    on(ReportActions.getReportURLSuccess, (state, { url }): IReportingState => ({...state, selectedReportURL: {...onLoadableSuccess(state.selectedReportURL), url: url}})),
    on(ReportActions.getReportURLFailure, (state, { error }): IReportingState => ({...state, selectedReportURL: {...onLoadableError(state.selectedReportURL, error), url: null}})),

    on(UserActions.logout, _ => ({
      ...createInitialReportingState()
    }))
)
